export const animateCss = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = (element instanceof jQuery) ? element[0] : document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd() {
            node.classList.remove(`${prefix}animated`, animationName);
            node.removeEventListener('animationend', handleAnimationEnd);

            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd);
    });

export const animateCssViewport = function () {
    var itemsToWatch = $('body .animate__viewport');
    itemsToWatch.each(function (i, element) {
        var elementWatcher = scrollMonitor.create(element);
        elementWatcher.enterViewport(function () {
            var classesSelector = $(element)[0].classList.value;
            if (classesSelector.indexOf("animate__viewport") > -1) {
                if ($(element).data('anim-viewport') !== undefined) {
                    var animationName = $(element).data('anim-viewport');
                    $(element).addClass(['animate__animated animate__' + animationName]);
                }
            }
        });
        elementWatcher.exitViewport(function () {
            $(element).removeClass(['animate__viewport']);
        });
    });
}